// src/api.js
const SCRIPT_URL = process.env.REACT_APP_SCRIPT_URL;

async function call(action, payload = {}) {
  try {
    const url = new URL(SCRIPT_URL);
    url.searchParams.append("action", action);
    url.searchParams.append("payload", JSON.stringify(payload));
    const res = await fetch(url.toString(), { method: "GET", mode: "cors" });
    const text = await res.text();
    const data = JSON.parse(text);
    if (data.error) throw new Error(data.error);
    return data;
  } catch (err) {
    console.error(`API error [${action}]:`, err);
    throw err;
  }
}

export const api = {
  init:             ()  => call("init"),
  getAll:           ()  => call("getAll"),
  purchase:         (p) => call("purchase", p),
  batch:            (p) => call("batch", p),
  transfer:         (p) => call("transfer", p),
  sale:             (p) => call("sale", p),
  cakeSale:         (p) => call("cakeSale", p),
  updateYields:     (p) => call("updateYields", p),
  updatePrices:     (p) => call("updatePrices", p),
  editEntry:        (p) => call("editEntry", p),
  deleteEntry:      (p) => call("deleteEntry", p),
  addOpeningStock:  (p) => call("addOpeningStock", p),
  addCollection:    (p) => call("addCollection", p),
};
